module.exports = __webpack_public_path__ + "8d6a9fbe733993e6c1d1700c208a4132.fbx";